// Server-pushed riskCalcStatus updates carry no configId — only the requestId
// of the subscribe request that created the subscription. The direct reply to
// that subscribe request echoes its body (with configId) under the same
// requestId, so remember requestId → configId from replies and resolve pushes
// through it. A connection can still hold subscriptions for models opened
// earlier, so this is how a status update is matched to its model.
const configIdByRequestId = new Map<string, string>();

interface StatusMessage {
	requestId?: string;
	requestBody?: unknown;
}

const readConfigId = (body: unknown): string | undefined => {
	let parsed = body;
	if (typeof body === 'string') {
		try {
			parsed = JSON.parse(body);
		} catch {
			return undefined;
		}
	}
	const configId = (parsed as { configId?: unknown } | undefined)?.configId;
	return typeof configId === 'string' ? configId : undefined;
};

/** The model a riskCalcStatus message belongs to, or undefined if unknown. */
export const resolveStatusConfigId = (
	data: StatusMessage,
): string | undefined => {
	const fromBody = readConfigId(data.requestBody);
	if (fromBody) {
		if (data.requestId) configIdByRequestId.set(data.requestId, fromBody);
		return fromBody;
	}
	return data.requestId ? configIdByRequestId.get(data.requestId) : undefined;
};
